import "./utils/fetch_monitor.js";
import { showToastMessage } from './utils/toast_message.js';
import { auth, GoogleAuthProvider, signInWithPopup, sendSignInLinkToEmail } from './utils/firebase_auth.js';

window.showToastMessage = showToastMessage;
window.firebaseAuth = auth;
window.GoogleAuthProvider = GoogleAuthProvider;
window.signInWithPopup = signInWithPopup;

let signinButton;
let pageSpinner;
let emailLinkBtn;

document.addEventListener('DOMContentLoaded', function() {
    initializeHomepage();
})

function initializeHomepage() {
    window.configAlertTimeout = document.getElementById('window-alert-timeout').dataset.alertTimeout;
    signinButton = document.getElementById('signin-btn');
    pageSpinner = document.getElementById('spinner-overlay');
    emailLinkBtn = document.getElementById("email-link-btn");

    if(!signinButton){
        return;
    }
    signinButton.onclick = () => {
        const loginModal = new bootstrap.Modal(
            document.getElementById('login-modal')
        );

        loginModal.show();
    }

    // Any landing-page CTA marked with data-open-login opens the sign-in modal
    document.querySelectorAll('[data-open-login]').forEach((button) => {
        button.onclick = () => {
            bootstrap.Modal.getOrCreateInstance(
                document.getElementById('login-modal')
            ).show();
        }
    });

    emailLinkBtn.addEventListener('click', async () => {
        const email =
        document.getElementById("email-login").value;

        const actionCodeSettings = {
            url: `${window.location.origin}/finish_signin`,
            handleCodeInApp: true
        };

        await sendSignInLinkToEmail(
            firebaseAuth,
            email,
            actionCodeSettings
        );

        localStorage.setItem(
            "emailForSignIn",
            email
        );

        showToastMessage("Check your email for a sign-in link.");
    });

    const googleLoginBtn = document.getElementById('google-login-btn');

    googleLoginBtn.onclick = async () => {
        const provider = new GoogleAuthProvider();

        const result = await signInWithPopup(
          firebaseAuth,
          provider
        );
        pageSpinner.classList.remove('d-none');
        const token = await result.user.getIdToken();

        await fetch("/auth/login", {
          method: "POST",
          headers: {
            "Authorization": `Bearer ${token}`
          }
        });

        location.reload();
    };
}